module.exports = __webpack_public_path__ + "img/hold.0e5b5d74.png";